export default __webpack_public_path__ + "static/media/10.d1873e63.mp3";